import { isBefore, subHours } from 'date-fns';
import { BuildingPdfStatus } from 'further-types/exit';

export const checkPdfsAreDownloadable = ({
  buildingPdfStatus,
  createdAt,
}: {
  buildingPdfStatus?: BuildingPdfStatus;
  createdAt?: Date;
}) => {
  return (
    buildingPdfStatus === undefined ||
    buildingPdfStatus === 'complete' ||
    (createdAt && isBefore(createdAt, subHours(new Date(), 1)))
  );
};
